"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactRelayContext_1 = require("./ReactRelayContext"); // eslint-disable-line @typescript-eslint/no-unused-vars
var relay_runtime_1 = require("relay-runtime");
var RelayEnvironmentProvider = function (props) {
    relay_runtime_1.RelayFeatureFlags.PREFER_FRAGMENT_OWNER_OVER_CONTEXT = true;
    return (React.createElement(ReactRelayContext_1.default.Provider, { value: { environment: props.environment, variables: {} } }, props.children));
};
exports.default = RelayEnvironmentProvider;
